import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import EmailObfuscationWrapper from '../utils/EmailObfuscationWrapper';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

interface Props {
  text: string;
  textClassName: string;
  expandTextClassName: string;
  textCutoffLength: number;
}

const ExpandableText = ({
  text,
  textClassName,
  expandTextClassName,
  textCutoffLength,
}: Props) => {
  const I18n = useI18nContext();

  const paragraphLength = text?.length ?? 0;
  const [showMoreOrLess, setShowMoreOrLess] = useState<'more' | 'less'>('more');
  const showMoreOrLessText =
    paragraphLength > textCutoffLength ? showMoreOrLess : null;

  return (
    <Box>
      <Typography
        className={textClassName}
        component="span"
        data-test-id="expandable-text"
      >
        <EmailObfuscationWrapper>
          {showMoreOrLessText === 'more'
            ? `${text.slice(0, textCutoffLength)}...`
            : text}
        </EmailObfuscationWrapper>
        {showMoreOrLessText !== null && (
          <AnalyticsWrappedComponent
            componentType={Box}
            eventText="Clicked View More or Less"
            eventLabel="View More or Less"
            data-track-click="View More or Less"
            data-test-id="show-more-or-less-text"
            onClick={() =>
              setShowMoreOrLess(showMoreOrLessText === 'more' ? 'less' : 'more')
            }
            className={expandTextClassName}
          >
            {showMoreOrLessText === 'more'
              ? I18n.t('components.expandable_text.view_more')
              : I18n.t('components.expandable_text.view_less')}
          </AnalyticsWrappedComponent>
        )}
      </Typography>
    </Box>
  );
};

export default ExpandableText;
